import React from "react";
import { View, Text, StyleSheet, Modal, Pressable } from "react-native";

import { BG_STYLES, COMMON_STYLES, CenterModal } from "@dehaat/dds";
import { useTranslation } from "react-i18next";

interface Props {
  visible: boolean;
  onClose: () => void;
  uploadFromCamera: () => void;
  uploadFromGallery: () => void;
}

const ImageSourceDialog = ({
  visible,
  onClose,
  uploadFromCamera,
  uploadFromGallery,
}: Props) => {
  const onPressCameraUpload = () => {
    uploadFromCamera();
  };
  const onPressGalleryUpload = () => {
    uploadFromGallery();
  };
  const { t } = useTranslation();

  return (
    <CenterModal isVisible={visible} onClose={onClose}>
      <Text style={styles.title}>{t("select_image_source")}</Text>
      <Pressable style={styles.button} onPress={onPressCameraUpload}>
        <Text style={styles.buttonText}>{t("take_Photo")}</Text>
      </Pressable>
      <Pressable style={styles.button} onPress={onPressGalleryUpload}>
        <Text style={styles.buttonText}>{t("choose_from_gallery")}</Text>
      </Pressable>
      <Pressable style={[{ marginTop: 10 }]} onPress={onClose}>
        <Text style={[{ fontSize: 14, color: "#888" }]}>{t("cancel")}</Text>
      </Pressable>
    </CenterModal>
  );
};

const styles = StyleSheet.create({
  title: {
    fontSize: 18,
    marginBottom: 12,
    fontWeight: "bold",
  },
  button: {
    backgroundColor: "#eee",
    paddingVertical: 12,
    paddingHorizontal: 20,
    marginVertical: 8,
    borderRadius: 8,
    width: "100%",
    alignItems: "center",
  },
  buttonText: {
    fontSize: 16,
  },
});

export default ImageSourceDialog;
